var map = {
	"./black/xiazaijietu.png": "uKjD",
	"./blue/xiazaijietu.png": "Y6wa",
	"./white/xiazaijietu.png": "WMrY"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1BxL";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/xiazaijietu\.png$
// module id = 1BxL
// module chunks = 24